import cx from 'classnames';
import { func, string, array, oneOfType, number } from 'prop-types';
import React from 'react';
import { Icon, Tooltip } from 'chaser-components';
import Svg from '../../Svg/index';
import style from './TableSort.module.scss';

const TableSort = ({
  sortFunc,
  currentSort,
  justifyContent,
  sortProp,
  headerTitle,
  tooltip,
  className,
}) => {
  const sortProperties = Array.isArray(sortProp) ? sortProp : [sortProp];
  const isSelected = sortProperties.some(str => currentSort.includes(str));
  const selectedStroke = isSelected ? '#3C4757' : '#9ba1ae';

  function getSymbol() {
    if (sortProperties.some(str => currentSort.includes(`-${str}`)))
      return (
        <Svg color="none" size={14}>
          <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
              fill={selectedStroke}
            />
            <path
              d="M7.83105 5.44042C8.02613 5.20746 8.37359 5.20747 8.56866 5.44044L11.6859 9.16335C11.9623 9.49341 11.7374 10.0091 11.3171 10.0091L8.19977 10.009L5.08241 10.0088C4.66211 10.0088 4.43725 9.49305 4.71364 9.16301L7.83105 5.44042Z"
              fill={selectedStroke}
            />
          </svg>
        </Svg>
      );
    return (
      <Svg color="none" size={14}>
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
            fill={selectedStroke}
          />
          <path
            d="M8.36893 10.7701C8.17385 11.0031 7.8264 11.0031 7.63132 10.7701L4.5139 7.04736C4.23751 6.71731 4.4624 6.20157 4.88271 6.20157L8.00002 6.2016L11.1174 6.20162C11.5377 6.20163 11.7626 6.71735 11.4862 7.04741L8.36893 10.7701Z"
            fill={selectedStroke}
          />
        </svg>
      </Svg>
    );
  }

  return (
    <div
      className={cx(style.header, style.sortIcon, className)}
      style={{ justifyContent }}
      onClick={() => sortFunc(sortProp)}
      data-testid={`sort-${sortProp}-btn`}
    >
      <span
        className={cx(style.title, isSelected && style.selected, !isSelected && style.notSelected)}
      >
        {headerTitle}
      </span>
      {tooltip && (
        <Tooltip content={tooltip} position="left" className={style.tooltip}>
          <Icon name="warning-circle" size={14} color="Mid Neutral 1" />
        </Tooltip>
      )}
      {getSymbol()}
    </div>
  );
};

TableSort.propTypes = {
  tooltip: string,
  className: string,
  justifyContent: string,
  headerTitle: string.isRequired,
  sortFunc: func.isRequired,
  sortProp: oneOfType([number, string, array]).isRequired,
  currentSort: string.isRequired,
};

TableSort.defaultProps = {
  tooltip: undefined,
  className: '',
  justifyContent: 'initial',
};

export default TableSort;
